import {action} from 'mobx';

import apiContentFolderGetAllStore from './apiContentFolderGetAllStore';
import ApiBaseStore from '../common/apiBaseStore';
import {STATE_PENDING, STATE_FULFILLED, STATE_REJECTED} from '../../../constants/asyncConstants';
import {EXPIRE_TIME, EXPIRES_IN, EXPIRES_PENDING} from '../../../constants/storeConstants';
import serverApi from '../../../utils/serverApi';

/**
 * ApiContentFolderDeleteStore
 */
class ApiContentFolderDeleteStore extends ApiBaseStore {
  /**
   * Makes the api request.
   *
   * @param {number|string} contentFolderId
   */
  @action makeRequest(contentFolderId) {
    if (!contentFolderId) {
      this.state = STATE_REJECTED;
      this.error = new Error('Invalid content folder id given to contentFolderDelete.');
      return;
    }

    this.state = STATE_PENDING;
    this[EXPIRE_TIME] = Date.now() + EXPIRES_PENDING;

    serverApi.contentFolderDelete(
      contentFolderId
    ).then(
      action('contentFolderDeleteSuccess', () => {
        this.error = null;
        this.state = STATE_FULFILLED;
        this.data = true;
        this[EXPIRE_TIME] = Date.now() + EXPIRES_IN;

        // Clear the content folder get all cache.
        apiContentFolderGetAllStore.refresh(true);
      }),
      action('contentFolderDeleteError', (error) => {
        this.error = error;
        this.state = STATE_REJECTED;
        this.data = false;
      })
    );
  }
}

export default new ApiContentFolderDeleteStore();
